<template>
  <div class="header dir-rtl" @click.self="toggleShowFreeSearchList">
    <div class="options-container">
      <freeSearchAdvOptions
        option="concat"
        :title="concatTitle"
        :message="concatMessage"
        :searchId="searchId"
      />
      <freeSearchAdvOptions
        option="shimush"
        :title="shimushTitle"
        :message="shimushMessage"
        class="h-xs"
        :searchId="searchId"
      />
      <freeSearchAdvOptions
        option="inOrder"
        :title="inOrderTitle"
        :message="inOrderMessage"
        class="h-larg"
        :searchId="searchId"
      />
      <!-- v-if="width=='wide'" -->
    </div>
    <freeSearchBarAdvanced :width="width" :searchId="searchId" />
  </div>
</template>

<script>
import freeSearchBarAdvanced from "./freeSearchBarAdvanced.vue";
import freeSearchAdvOptions from "./freeSearchAdvOptions.vue";
import { createFreeSearchBookListStore } from "@/store_pinia";
export default {
  components: {
    freeSearchBarAdvanced,
    freeSearchAdvOptions,
  },

  props: ["width", "searchId"],

  computed: {
    freeSearchBookListStore() {
      return createFreeSearchBookListStore(this.searchId);
    },
    concatTitle() {
      return this.$t("freeSearchInput.advancedOptions.concatTitle");
    },
    concatMessage() {
      return this.$t("freeSearchInput.advancedOptions.concatMessage");
    },
    shimushTitle() {
      return this.$t("freeSearchInput.advancedOptions.shimushTitle");
    },
    shimushMessage() {
      return this.$t("freeSearchInput.advancedOptions.shimushMessage");
    },
    inOrderTitle() {
      return this.$t("freeSearchInput.advancedOptions.inOrderTitle");
    },
    inOrderMessage() {
      return this.$t("freeSearchInput.advancedOptions.inOrderMessage");
    },
  },
  methods: {
    toggleShowFreeSearchList() {
      this.freeSearchBookListStore.toggleShowFreeSearchList();
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.options-container {
  display: flex;
  flex-direction: row;
  justify-content: right;
}
</style>
